import { Fraga } from "@/types/riskbedomning";

export const specialarbetenFragor: Fraga[] = [
  {
    id: "osa-risker",
    text: "Finns risker kopplade till organisatorisk och social arbetsmiljö (OSA)?",
    kategori: "Specialarbeten & miljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Finns det risk för hög arbetsbelastning utan planerade åtgärder för hantering?",
      "Finns det risk att rutiner för att hantera konflikter och stress saknas?",
      "Finns det risk för bristande kommunikation mellan olika yrkeskategorier och språkgrupper?"
    ],
    afsReferences: ["AFS 2015:4"]
  },
  {
    id: "belastningsergonomi",
    text: "Riskerar arbetet att medföra belastningsskador på grund av tunga eller monotona moment?",
    kategori: "Specialarbeten & miljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Riskerar avsaknad av arbetsrotation att orsaka skador eller utmattning?",
      "Riskerar nödvändiga hjälpmedel som lyftverktyg eller exoskelett att saknas i arbetet?",
      "Riskerar personalen att sakna kunskap om säker lyftteknik och arbetsställningar?",
      "Finns risk för manuella lyft och otillräcklig hanteringsutrustning?"
    ],
    afsReferences: ["AFS 2012:2"]
  },
  {
    id: "tillfälliga-elinstallationer",
    text: "Finns risker med tillfälliga elinstallationer på byggarbetsplatsen?",
    kategori: "Specialarbeten & miljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Kan bristande elinstallationer, felaktig dimensionering eller uteblivet underhåll leda till kortslutning, överbelastning eller jordfel med risk för brand eller elchock?",
      "Är kablar och uttag skyddade mot fukt, vatten och mekanisk påverkan?",
      "Vem ansvarar för temporära elinstallationer?",
      "Hur skyddas kablar från skador av fordon eller arbete?"
    ],
    afsReferences: ["AFS 2008:11"]
  },
  {
    id: "belysning-arbetsplats",
    text: "Finns risk för otillräcklig arbetsbelysning?",
    kategori: "Specialarbeten & miljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Kan bristande belysning göra arbetet svårt att utföra på ett säkert sätt?",
      "Finns risk att belysningen inte kan anpassas till individuella behov eller arbetsuppgifter?",
      "Kan brist på dagsljus eller otillräcklig avskärmning mot solinstrålning skapa obehag eller försämra arbetsmiljön?",
      "Kan bristande nödbelysning göra det svårt att uppfatta varningsskyltar eller se maskindelar vid ett strömavbrott?",
      "Kan belysningen tillsammans med golvets egenskaper skapa bländning, dålig sikt?"
    ],
    afsReferences: ["AFS 2009:2"]
  },
  {
    id: "golv-halkrisk",
    text: "Kan golvens utformning eller material öka risken för att någon halkar eller snubblar?",
    kategori: "Specialarbeten & miljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Kan bristande golvstyrka eller ojämna ytor skapa risker vid truckkörning eller tung transport?",
      "Kan bristande markering, belysning eller avgränsning av nivåskillnader skapa risk för fall, snubbling eller kollisioner?"
    ],
    afsReferences: ["AFS 2009:2"]
  }
];